import { apiFetch } from "@/lib/api-client";

export interface AdminUser {
  id: number;
  username: string;
  display_name?: string;
  role: "user" | "company_admin" | "super_admin";
  company_id: number | null;
  is_active: number;
  created_at?: string;
  last_login_at?: string | null;
  company_name?: string | null;
  phone?: string | null;
  email?: string | null;
}

export interface CreateUserPayload {
  username: string;
  password: string;
  display_name?: string;
  company_id?: number | null;
  role?: "user" | "company_admin";
  /** 绑定后可短信登录 */
  phone?: string;
  /** 填写则发送欢迎邮件 */
  email?: string;
}

export interface UpdateUserPayload {
  display_name?: string;
  password?: string;
  is_active?: number;
  role?: "user" | "company_admin" | "super_admin";
  /** "" = 解绑 */
  phone?: string;
  /** "" = 清空 */
  email?: string;
}

export async function listUsers(includeInactive = false) {
  const qs = includeInactive ? "?include_inactive=true" : "";
  return apiFetch<{ success: boolean; data: AdminUser[] }>(`/api/admin/users${qs}`);
}

export async function createUser(p: CreateUserPayload) {
  return apiFetch<{ success: boolean; user_id: number }>("/api/admin/users", {
    method: "POST",
    body: JSON.stringify(p),
  });
}

export async function updateUser(id: number, p: UpdateUserPayload) {
  return apiFetch<{ success: boolean }>(`/api/admin/users/${id}`, {
    method: "PATCH",
    body: JSON.stringify(p),
  });
}

export async function deleteUser(id: number) {
  return apiFetch<{ success: boolean }>(`/api/admin/users/${id}`, { method: "DELETE" });
}
